import React from "react";

/**
 * DPGMascot — Guard-dog mascot for the Digital Personal Guard.
 *
 * Uses the DogMascot.png image with mood-driven CSS animations
 * (bounce, shake, pulse, tilt, etc.) applied to the container.
 *
 * Props:
 *  - mood: "idle" | "greeting" | "thinking" | "alert" | "happy" | "concerned" | "scanning" | "sleeping"
 *  - size: number (default 64)
 *  - onClick: function
 *  - className: string
 */
function DPGMascot({ mood = "idle", size = 64, onClick, className = "" }) {
  const moodClass = `dpg-mascot dpg-mascot--${mood} ${className}`.trim();

  return (
    <div
      className={moodClass}
      onClick={onClick}
      style={{
        width: size,
        height: size,
        cursor: onClick ? "pointer" : "default",
      }}
      role={onClick ? "button" : "img"}
      aria-label={`Digital Personal Guard — ${mood}`}
      tabIndex={onClick ? 0 : undefined}
    >
      <img
        src="/DogMascot.png"
        alt="KinShield Guard Dog"
        className="dpg-mascot-img"
        width={size}
        height={size}
        draggable={false}
      />
    </div>
  );
}

export default DPGMascot;
